/* eslint-disable no-unused-expressions */

import * as Yup from "yup";
import checkout from "../../new-voucher/schemas/form";

const {
  formField: { title, description, recommendation, value },
} = checkout;
const validations = [
  // validation for voucher Info page
  Yup.object().shape({
    [title.name]: Yup.string()
      .matches(/([A-Za-z])/, title.invalidMsg)
      .required(title.errorMsg),
    [description?.name]: Yup.string().required(description?.errorMsg),
    [recommendation?.name]: Yup.object().required(recommendation?.errorMsg),
  }),

  // validations for additional info Page
  Yup.object().shape({
    [value?.name]: Yup.string().when("type", {
      is: "percentage",
      then: () =>
        Yup.string()
          .test("isPercentage", "Value must be a percentage between 0 and 100", (valueV) => {
            if (!valueV) return true; // Allow empty values
            const percentageValue = parseFloat(valueV);
            return percentageValue > 0 && percentageValue < 100;
          })
          .required(value?.errorMsg1),
      otherwise: () => Yup.string().required(value?.errorMsg2),
    }),
  }),
];

export default validations;
